
export const types = {
    login: '[Auth] Login',
    logout: '[Auth] Logout',

    uiSetError: '[UI] Set Error',
    uiRemoveError: '[UI] Remove Error',

    uiStartLoading: '[UI] Start Loading',
    uiFinishLoading: '[UI] Finish Loading',

    notesAddNew: '[Notes] New note',
    notesActive: '[Notes] Set Active note',
    notesLoad: '[Notes] Load note',
    notesUpdated: '[Notes] Updated note',
    notesFileUrl: '[Notes] Updataed images url',
    notesDelete: '[Notes] Delete note',
    notesLogoutCleaning: '[Notes] Logout Cleaning',
}